import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IEvent, IEventsRequestModel, IPatchStatusModel } from '../../../models/index';

export const EventApis = {
  async callCreateEventApi(
    eventData: IEventsRequestModel
  ) {
    return apiWrapper.post<IEvent>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events`,
      eventData,
      headersInstance()
    );
  },

  async callUpdateEventApi(
    eventData: IEventsRequestModel,
    version: number
  ) {
    return apiWrapper.put<IEvent>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/${eventData.eventName}/version/${version}`,
      eventData,
      headersInstance()
    );
  },

  async callPatchStatusEventApi(
    patchStatusData: IPatchStatusModel,
    eventName: string,
    version: number
  ) {
    return apiWrapper.patch<IEvent>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/${eventName}/version/${version}`,
      patchStatusData,
      headersInstance()
    );
  },
};
